(ns manage.ad-variant.creation.video-format-picker
  "The OLV/STV choice, shared by ad-builder creation and manual ad upload: both
   let a video ad pick between regular online video and Amazon Prime's streaming TV."
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Checkbox$default" :as Checkbox]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/type/adset_channel/connected_tv.svg$default" :as CtvIcon]
            ["src/svg/type/thumbnails/meta-single-video.svg$default" :as SingleVideoThumbnail]
            [uix.core :refer [$ defui]]))

(def video-formats
  {"olv" {:thumbnail SingleVideoThumbnail
          :title "OLV"
          :description "Reach audiences on websites, apps, and video platforms."}
   "stv" {:thumbnail CtvIcon
          :title "STV"
          :description "Reach audiences on streaming TV platforms like Amazon Prime Video."}})

(defui video-format-card
  "One of two mutually exclusive cards: selecting one deselects the other.
   Clicking the selected card again clears the selection."
  [{:keys [thumbnail title description value selected-value on-click]}]
  (let [selected (= value selected-value)]
    ($ Box
       {:width 240
        :on-click #(on-click (if selected nil value))
        :sx #js {:minHeight 220
                 :cursor "pointer"
                 :border 2
                 :borderColor (if selected "primary.main" "#14082040")
                 :backgroundColor (if selected "primary.100" "white")
                 :borderRadius 2
                 :p 2}}
       ($ Stack {:direction "row"
                 :justifyContent "space-between"
                 :alignItems "flex-start"}
          ($ Typography {:variant "h5"} title)
          ($ Checkbox {:checked selected
                       :sx #js {:p 0}}))
       ($ Stack {:alignItems "center" :sx #js {:py 2}}
          ($ thumbnail {:width 88 :height 88}))
       ($ Typography {:variant "body2" :textAlign "center"} description))))

(defui video-format-selector
  [{:keys [video-format set-video-format]}]
  ($ Stack {:direction "row" :sx #js {:gap 2}}
     (for [[value cfg] video-formats]
       ($ video-format-card
          (assoc cfg
                 :key value
                 :value value
                 :selected-value video-format
                 :on-click set-video-format)))))
